import React from 'react'
import styles from './dashboard.module.css'
import { setStorage } from '../../utils'
import constant from '../../constant'
const DemoAdvertiseBanner = ({setShowDemoBanner}) => {
    const onSkip = () => {
        setShowDemoBanner(false)
        setStorage(constant.keys.skippedDemoBanner, true)
    }
    return (
        <React.Fragment>
            <div className={`${styles['mv-none']} col-md-12`}>
                <div className='mt-3 bg'>
                    <div className={`${styles['demo-card']} card`}>
                        <div className='card-body'>
                            <div className='d-flex justify-content-between'>
                                <h1>Experience Our Product Live!</h1>
                                <a className={`${styles['book-btn']} btn`} href='#'>Book a Demo Now</a>
                            </div>
                            <div className='d-flex justify-content-between'>
                                <p className='mb-0 w-75'>Schedule a free live training session with one of our product experts to discover how you can optimize your organization's hiring process. See our innovative solution in action and learn how it can transform your recruitment strategy.</p>
                                <p className='mt-5 mb-0'><a className={`${styles['skip-btn']} btn`} href='javascript:void(0);' onClick={()=>{
                                    onSkip()
                                }}>Skip</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default DemoAdvertiseBanner